import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';


EDC.Games.CarouselImageMulti.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);
  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.CarouselImageMulti.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.answers = [];
  this.correctAnswers = 0;
};

EDC.Games.CarouselImageMulti.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.CarouselImageMulti.Scenes.Main.prototype.constructor = EDC.Games.CarouselImageMulti.Scenes.Main;

const CIM = EDC.Games.CarouselImageMulti.Scenes.Main.prototype;

CIM.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

CIM.createTemplateUI = function () {
  let title; let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  const horseBack1 = this.add.sprite(930, 600, 'horse-back');
  const horseBack2 = this.add.sprite(1430, 600, 'horse-back');
  horseBack1.direction = 1;
  horseBack2.direction = -1;
  const carousel = this.add.sprite(1150, 510, 'carousel');
  const sign = this.add.sprite(310, 500, 'sign');
  if (titleImg) {
    title = this.add.sprite(310, 190, 'title').setOrigin(0.5);
  } else {
    title = this.make.text({
      x: 330,
      y: 175,
      text: this.gameConfig.titleTxt,
      origin: { x: 0.5, y: 0.5 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.titleSize}`,
        wordWrap: { width: '600' },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
  const instructionsFrame = this.add.sprite(this.game.config.width / 2 + 200, 150, 'instructions-panel');
  if (instructionsImg) {
    instructions = this.add.sprite(this.game.config.width / 2 + 200, 150, 'instructions').setOrigin(0.5);
  } else {
    instructions = this.make.text({
      x: this.game.config.width / 2 + 200,
      y: 150,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0.5, y: 0.5 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: '800' },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
  this.scaleAnimation(instructions);
  this.moveHorse(horseBack1, 15);
  this.moveHorse(horseBack2, 15);
};

CIM.moveHorse = function (sprite, altitude) {
  sprite.direction *= -1;
  const rndDuration = 1250 + Math.floor(Math.random() * 500);
  sprite.moveAnim = this.tweens.add({
    targets: sprite,
    y: sprite.y + altitude * sprite.direction,
    duration: rndDuration,
    ease: 'Linear',
    yoyo: true,
    repeat: -1,
  });
};

CIM.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  this.tweens.add({
    targets: sprite,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 400,
    ease: 'Sine.easeInOut',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 6000 + Math.floor(Math.random() * 3000)),
  });
};

CIM.loadIteration = function () {
  this.createHorses();
};

CIM.createHorses = function () {
  const { images } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { correct } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const answer = {
    0: {
      x: 640, y: 550, sprite: 'horse-left', depth: 0, maskY: 102,
    },
    1: {
      x: 980, y: 550, sprite: 'horse-mid', depth: 0, maskY: 53,
    },
    2: {
      x: 1370, y: 510, sprite: 'horse-mid', depth: 1, maskY: 60,
    },
    3: {
      x: 1670, y: 550, sprite: 'horse-right', depth: 0, maskY: 108,
    },
  };
  let direction = 1;
  const font = {
    font: `140px ${this.gameConfig.font}`,
  };
  for (let i = 0; i < 4; i++) {
    const shape = this.make.graphics().fillRect(answer[i].x - 2, answer[i].maskY, 20, 190);
    const geomask = shape.createGeometryMask();
    geomask.invertAlpha = true;
    direction *= -1;
    const container = this.add.container(answer[i].x, answer[i].y).setDepth(answer[i].depth);
    const horse = this.add.sprite(0, 220, answer[i].sprite);
    const pole = this.add.sprite(0, -65, 'pole');
    const letterPanel = this.add.sprite(0, 0, 'letter-panel');
    const asset = this.gameConfig.assets[images[i]];
    const text = this.add.text(0, 5, asset.text, font).setOrigin(0.5);
    container.add(pole);
    container.add(horse);
    container.add(letterPanel);
    container.add(text);
    container.setSize(260, 600);
    if (correct.indexOf(asset.id) !== -1) {
      container.isCorrect = true;
      this.correctAnswers = this.correctAnswers + 1;
    }
    container.setMask(geomask);
    container.direction = direction;
    const rect = new Phaser.Geom.Rectangle(0, 0, 260, 600);
    container.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
    this.cursorManager.setDefaultDraggableEvents(container);
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    this.moveHorse(container, 40);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.answers.push(container);
  }
};

CIM.nextIteration = function () {
  this.answers.map((x) => {
    x.setDepth(0);
  });
  this.iteration++;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.answers.map((x) => {
      x.destroy();
    });
    this.answers = [];
    this.correctAnswers = 0;
    this.loadIteration();
  }
};

CIM.checkAnswer = function (answer) {
  if (answer.isCorrect) {
    this.correctAnswers--;
    this.playCorrect();
    answer.disableInteractive();
    answer.moveAnim.stop();
    answer.getData('markAnim').showMark(true, () => {});
    if (this.correctAnswers === 0) {
      this.answers.map((x) => {
        x.disableInteractive();
        x.moveAnim.stop();
      });
      this.time.delayedCall(2500, this.nextIteration, [], this);
    }
  } else {
    answer.next.setTint(0xff0000);
    answer.getAt(2).setTint(0xff0000);
    answer.getAt(3).setTint(0xff0000);
    answer.moveAnim.stop();
    answer.disableInteractive();
    this.playWrong();
    answer.getData('markAnim').showMark(false, () => {});
  }
};

export default EDC.Games.CarouselImageMulti.Scenes.Main;
